import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UserDashboardLayer from "../admin_dashboard/UserDashboardLayer";

const UserDashboard = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="User Dashboard" />

        {/* UserDashboardLayer */}
        <UserDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default UserDashboard;
